import React from "react";
import { Link } from "react-router-dom";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { leftMenuHide, leftMenuShow } from "../../../actions/LeftMenuActions";
import { ScreenFormatContext } from "@mnjsplatform/data";
import LeftMenuItems from "./LeftMenuItems";

const Logo = ({ isDesktop }) => {

  const dispatch = useDispatch();

  const hideMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(leftMenuHide());
  }

  const desktopLogo = () => {
    return (
      <div className="logobar d-none d-md-flex justify-content-between align-items-center pt-4 pb-4">
        <Link to="./">
          <img className="app_logo" alt=""/>
        </Link>
        <i className="btn-menu btn-menu-hide fa fa-chevron-left"
           title={i18next.t("HideMenu")}
           onClick={hideMenu}
        />
      </div>
    )
  }

  const mobileLogo = () => {
    return (
      <nav className="navbar navbar-dark bg-dark navbar-expand-xl d-xl-none d-md-none w-100">
        <Link to="./">
          <img className="app_logo mobile" alt=""/>
        </Link>
        <button className="navbar-toggler collapsed" type="button" data-toggle="collapse"
                data-target="#bd-docs-nav"><span className="menu"><i className="material-icons">menu</i></span>
        </button>
      </nav>
    )
  }

  return isDesktop ? desktopLogo() : mobileLogo();
}

const LeftMenu = ({widthClass}) => {

  const dispatch = useDispatch();

  const displayMenu = useSelector(({leftMenuReducer}) => {
    return leftMenuReducer.displayMenu
  });

  const showMenu = () => {
    dispatch(leftMenuShow());
  };

  const getContainerClass = (isDesktop) => {
    let classContainer = "menu-container";
    if (!isDesktop || displayMenu) {
      classContainer += ` cr-b-gr-1 p-0 h-auto border-bottom-0 ${widthClass}`;
    } else {
      classContainer += ` collapsed`;
    }
    return classContainer;
  }

  return (<ScreenFormatContext.Consumer>
    {
      (isDesktop) => {
        const display = (displayMenu || !isDesktop);
        return (
          <div id={"menu-container"} className={getContainerClass(isDesktop)}>
            {display &&
              <Logo isDesktop={isDesktop} /> ||
              <i className="btn-menu btn-menu-show fa fa-chevron-right"
                 title={i18next.t("ShowMenu")}
                 onClick={showMenu}
              />
            }
            {display &&
              <div className="sticky-top">
                <LeftMenuItems dispatch={dispatch} isDesktop={isDesktop}/>
              </div>
            }
          </div>
        )
      }
    }
  </ScreenFormatContext.Consumer>
  );
};

export default LeftMenu;